import { useEffect, useState } from "react"

export function useKeyboardOpen() {
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(false)

    useEffect(() => {
        let timeout: ReturnType<typeof setTimeout> | null = null

        const update = () => {
            if (!window.visualViewport) return
            const ratio = window.visualViewport.height / window.innerHeight
            // Keyboard is open when visual viewport is significantly smaller than the window
            setIsKeyboardOpen(ratio < 0.8)
        }

        const handleFocusIn = (e: FocusEvent) => {
            const tag = (e.target as HTMLElement)?.tagName
            if (tag === "INPUT" || tag === "TEXTAREA") {
                // Delay slightly to let visualViewport finish updating
                if (timeout) clearTimeout(timeout)
                timeout = setTimeout(update, 150)
            }
        }

        const handleFocusOut = (e: FocusEvent) => {
            const tag = (e.target as HTMLElement)?.tagName
            if (tag === "INPUT" || tag === "TEXTAREA") {
                if (timeout) clearTimeout(timeout)
                timeout = setTimeout(update, 150)
            }
        }

        if (window.visualViewport) {
            window.visualViewport.addEventListener("resize", update)
        }
        window.addEventListener("focusin", handleFocusIn)
        window.addEventListener("focusout", handleFocusOut)
        update()

        return () => {
            if (timeout) clearTimeout(timeout)
            window.visualViewport?.removeEventListener("resize", update)
            window.removeEventListener("focusin", handleFocusIn)
            window.removeEventListener("focusout", handleFocusOut)
        }
    }, [])

    return isKeyboardOpen
}
